namespace $.$$ {
	export class $shm_hitalama_keepsize extends $.$shm_hitalama_keepsize {
		
		@ $mol_mem
		transform() {
			if( !this.min_zoom() ) return `scale(calc(1 / ${ this.zoom() })`
			return `scale(calc(1 / min(${this.min_zoom()}, ${ this.zoom() }))`
		}

		translate() {
			const x = this.anchor_hor() == 'left' ? '0' : '-100%'
			const y = this.anchor_vert() == 'top' ? '0' : '-100%'
			return x+' '+y
		}

		transformOrigin() {
			const x = this.anchor_hor() == 'left' ? '0' : '100%'
			const y = this.anchor_vert() == 'top' ? '0' : '100%'
			return x+' '+y
		}
		
	}
}
